export default __webpack_public_path__ + "static/media/surveillance-video.0d3a4e89.mp4";